import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Heading,
  Spinner,
  Stack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Avatar,
  Text,
  Container,
  Button,
  HStack,
  Icon,
} from "@chakra-ui/react";
import * as mod from "../../url";
import Sidebar from "../Sidebar";
import Navbar from "../Navbar/Navbar";
import { FaWhatsapp } from "react-icons/fa";

export default function Results() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [categoryPage, setCategoryPage] = useState(1);
  const [candidatePages, setCandidatePages] = useState({});

  const SIDEBAR_WIDTH = "250px";
  const CATEGORIES_PER_PAGE = 10;
  const CANDIDATES_PER_PAGE = 5;

  const fetchResults = async () => {
    try {
      const res = await axios.get(
        `${mod.api_url}/api/v1/election/vote/votes/candidate-wise`,
      );
      setData(res.data);

      // initialize candidate pages
      const pageMap = {};
      res.data.forEach((cat) => {
        pageMap[cat.categoryId] = 1;
      });
      setCandidatePages(pageMap);
    } catch (error) {
      console.error("Error fetching results", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search.toLowerCase());
      setCategoryPage(1); // reset category pagination
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    fetchResults();
  }, []);

  if (loading) {
    return (
      <Box
        minH="60vh"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Spinner size="xl" />
      </Box>
    );
  }

  /* ================= CATEGORY PAGINATION ================= */
  const filteredCategories = data
    .map((category) => {
      // filter candidates by name
      const filteredCandidates = category.candidates.filter((c) =>
        c.name.toLowerCase().includes(debouncedSearch),
      );

      // check category match OR candidate match
      const isCategoryMatch = category.categoryName
        .toLowerCase()
        .includes(debouncedSearch);

      if (isCategoryMatch) {
        return category; // show full category
      }

      if (filteredCandidates.length > 0) {
        return {
          ...category,
          candidates: filteredCandidates,
        };
      }

      return null;
    })
    .filter(Boolean);
  const totalCategoryPages = Math.ceil(
    filteredCategories.length / CATEGORIES_PER_PAGE,
  );

  const catStart = (categoryPage - 1) * CATEGORIES_PER_PAGE;
  const catEnd = catStart + CATEGORIES_PER_PAGE;

  const paginatedCategories = filteredCategories.slice(catStart, catEnd);

  return (
    <>
      <Sidebar />
      <Navbar />

      <Box ml={{ base: 0, md: SIDEBAR_WIDTH }} mt="70px" p={5} bg="gray.50">
        <Container maxW="6xl">
          <Heading textAlign="center" mb={6}>
            Election Results
          </Heading>
          <Box mb={6}>
            <input
              type="text"
              placeholder="Search by candidate or category name..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "8px",
                border: "1px solid #3904c9ff",
              }}
            />
          </Box>
          <Stack spacing={6}>
            {paginatedCategories.map((category, ind) => {
              /* ============ CANDIDATE PAGINATION ============ */
              const currentCandidatePage =
                candidatePages[category.categoryId] || 1;

              const totalCandidatePages = Math.ceil(
                category.candidates.length / CANDIDATES_PER_PAGE,
              );

              const candStart =
                (currentCandidatePage - 1) * CANDIDATES_PER_PAGE;
              const candEnd = candStart + CANDIDATES_PER_PAGE;

              const paginatedCandidates = category.candidates.slice(
                candStart,
                candEnd,
              );

              return (
                <Box
                  key={category.categoryId}
                  borderWidth="1px"
                  borderRadius="lg"
                  p={4}
                  bg="white"
                >
                  <Heading
                    size="md"
                    mb={4}
                    className="text-primary"
                    textAlign="left"
                  >
                    {ind + 1}. {category.categoryName}
                  </Heading>

                  <Table variant="simple">
                    <Thead bg="gray.100">
                      <Tr>
                        <Th>Rank</Th>
                        <Th>Candidate</Th>
                        <Th>Photo</Th>
                        <Th>Chat</Th>
                        <Th isNumeric>Votes</Th>
                      </Tr>
                    </Thead>

                    <Tbody>
                      {paginatedCandidates.map((c) => (
                        <Tr key={c.candidateId}>
                          <Td>{c.serial}</Td>
                          <Td>
                            <Text fontWeight="medium">{c.name}</Text>
                          </Td>

                          {/* <Avatar src={c.photo} name={c.name} size="md" /> */}
                          <Td style={{ maxHeight: "200px", maxWidth: "100px" }}>
                            <img
                              src={`${mod.api_url}${c?.photo}`}
                              style={{
                                maxHeight: "110px",
                                width: "100px",
                                objectFit: "cover",
                                borderRadius: "8px",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                              }}
                            />
                          </Td>
                          <Td>
                            {/* <span>{c.mobile}</span> */}

                            <HStack spacing={2}>
                              {c.mobile && (
                                <Icon
                                  as={FaWhatsapp}
                                  boxSize={7}
                                  color="pink.600"
                                  cursor="pointer"
                                  onClick={() =>
                                    window.open(
                                      `https://wa.me/91${c.mobile}`,
                                      "_blank",
                                    )
                                  }
                                  _hover={{ color: "green.600" }}
                                />
                              )}
                            </HStack>
                          </Td>
                          <Td isNumeric>{c.totalVotes}</Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>

                  {/*  Candidate Pagination */}
                  {totalCandidatePages > 1 && (
                    <HStack justify="space-between" mt={3}>
                      <Button
                        size="sm"
                        isDisabled={currentCandidatePage === 1}
                        onClick={() =>
                          setCandidatePages((prev) => ({
                            ...prev,
                            [category.categoryId]: currentCandidatePage - 1,
                          }))
                        }
                      >
                        Prev
                      </Button>

                      <Text fontSize="sm">
                        Page {currentCandidatePage} of {totalCandidatePages}
                      </Text>

                      <Button
                        size="sm"
                        isDisabled={
                          currentCandidatePage === totalCandidatePages
                        }
                        onClick={() =>
                          setCandidatePages((prev) => ({
                            ...prev,
                            [category.categoryId]: currentCandidatePage + 1,
                          }))
                        }
                      >
                        Next
                      </Button>
                    </HStack>
                  )}
                </Box>
              );
            })}
          </Stack>

          {/*  GLOBAL CATEGORY PAGINATION */}
          <HStack justify="center" spacing={4} mt={10}>
            <Button
              isDisabled={categoryPage === 1}
              onClick={() => setCategoryPage((p) => p - 1)}
            >
              Previous
            </Button>

            <Text>
              Page <b>{categoryPage}</b> of <b>{totalCategoryPages}</b>
            </Text>

            <Button
              isDisabled={categoryPage === totalCategoryPages}
              onClick={() => setCategoryPage((p) => p + 1)}
            >
              Next
            </Button>
          </HStack>
        </Container>
      </Box>
    </>
  );
}
